import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from 'app/shared/core/pipes/pipes.module';
import { UIKitButtonModule } from 'app/shared/ui-kit';
import {
  UIKitActionItemComponent,
  UIKitActionListComponent,
  UIKitActionMenuComponent,
  UIKitActionMenuItemComponent,
} from 'app/shared/ui-kit/action-list/action-list';
import { UIKitFormFieldModule } from 'app/shared/ui-kit/form-field/form-field.module';
import { UIKitIconModule } from 'app/shared/ui-kit/icon';

@NgModule({
  imports: [
    CommonModule,
    UIKitIconModule,
    UIKitButtonModule,
    UIKitFormFieldModule,
    MatMenuModule,
    PipesModule,
    TranslocoModule,
    UIKitActionListComponent,
    UIKitActionItemComponent,
  ],
  declarations: [UIKitActionMenuComponent, UIKitActionMenuItemComponent],

  exports: [
    UIKitActionItemComponent,
    UIKitActionMenuComponent,
    UIKitActionMenuItemComponent,
    UIKitActionListComponent,
    UIKitActionItemComponent,
  ],
})
export class UIKitActionListModule {}
